module.exports = __webpack_public_path__ + "static/media/skyline.5fa0ec9d.jpg";